import React from 'react';
import { FormControl, TextField } from '@mui/material';
import { SelectTypography } from '../ScenarioLibrary.Styled';
import { SearchIcon } from '../../../assets/images/UI-dashboard';

interface SearchFieldProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSearchClick: () => void;
}

const SearchField: React.FC<SearchFieldProps> = ({ value, onChange, onSearchClick }) => {
  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      onSearchClick();
    }
  };
  return (
    <FormControl
      style={{
        marginRight: '20px',
        marginLeft: '10px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}
    >
      <SelectTypography>Search: </SelectTypography>
      <TextField
        placeholder="Enter scenario name"
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyPress}
        style={{
          width: '180px',
          borderRight: 'none !important',
          borderTopRightRadius: '0px',
          borderBottomRightRadius: '0px',
        }}
        InputLabelProps={{
          shrink: true,
        }}
        sx={{
          width: '180px',
          borderTopRightRadius: '0px',
          borderBottomRightRadius: '0px',
          '& .MuiOutlinedInput-root': {
            borderTopRightRadius: '0px !important',
            borderBottomRightRadius: '0px !important',
            height: '24px',
            borderRadius: '4px',
            fontSize: '10px',
            color: '#333333',
            borderColor: '#CCCCCC',
            borderRight: 'none !important',
            '& fieldset': {
              borderColor: '#CCCCCC',
            },
            '&:hover fieldset': {
              borderColor: '#CCCCCC',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#CCCCCC',
            },
          },
          '& .MuiInputLabel-root': {
            color: 'rgba(0, 0, 0, 0.4)',
            '&.Mui-focused': {
              color: '#CCCCCC',
            },
          },
          '& .MuiFormHelperText-root': {
            textAlign: 'left',
          },
        }}
      />
      <div
        style={{
          background: '#DF2020',
          width: '22px',
          height: '24px',
          cursor: 'pointer',
          borderTopRightRadius: '4px',
          borderBottomRightRadius: '4px',
        }}
        onClick={onSearchClick}
      >
        <img style={{ marginLeft: '5px' }} src={SearchIcon} alt="search-icon" />
      </div>
    </FormControl>
  );
};

export default SearchField;
